export default __webpack_public_path__ + "media/Microsoft-logo-wht-sm.b5c067a9.svg";